export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20scene%20with%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20film%20reel%20texture%20on%20edges%2C%20abstract%20geometric%20patterns%20in%20the%20background%2C%20luxurious%20velvet%20curtains%20with%20golden%20trim%2C%20atmospheric%20haze%2C%20professional%20cinematography%20aesthetic%2C%20rich%20contrast%2C%20no%20text%20no%20people%2C%20elegant%20entertainment%20atmosphere&width=1920&height=1080&seq=hero-bg-mitao-2026&orientation=landscape"
          alt="密桃视频 - 沉浸式观影体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative w-full z-10 px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-5">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs md:text-sm text-background-50/90 font-medium whitespace-nowrap">
                每日更新 · 高清不缓冲
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              密桃视频 - 您的免费高清视频聚合平台
            </h1>

            <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-3">
              全网热门资源一网打尽，追剧看片首选
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-7 max-w-xl mx-auto lg:mx-0">
              密桃视频汇聚91视频、91视频网站、久久视频等热门平台资源，每日更新最新电影电视剧。高清全集在线观看不缓冲，91在线视频流畅播放无卡顿，覆盖动作、喜剧、悬疑、爱情、科幻等全类型影片。无论是最新院线大片还是经典老片，密桃视频都为影迷提供一站式观影体验，追剧从此不再等待。
            </p>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start mb-7">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-movie-line text-accent-400 text-base md:text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-background-50 whitespace-nowrap">20000+</div>
                  <div className="text-xs text-background-50/60 whitespace-nowrap">海量影片资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-400 text-base md:text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-background-50 whitespace-nowrap">每日更新</div>
                  <div className="text-xs text-background-50/60 whitespace-nowrap">最新剧集同步</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-400 text-base md:text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-base md:text-lg font-bold text-background-50 whitespace-nowrap">高清流畅</div>
                  <div className="text-xs text-background-50/60 whitespace-nowrap">不缓冲不卡顿</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors text-center cursor-pointer"
              >
                <i className="ri-fire-line mr-2"></i>查看热门排行
              </a>
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-7 py-3.5 rounded-full border border-background-50/30 text-background-50 text-sm md:text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors text-center cursor-pointer"
              >
                <i className="ri-timer-line mr-2"></i>最新更新动态
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-sm md:max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20theater%20lighting%2C%20film%20strips%20and%20golden%20spotlights%2C%20abstract%20movie%20poster%20aesthetic%20with%20soft%20glow%2C%20elegant%20entertainment%20visual%2C%20rich%20amber%20and%20deep%20burgundy%20tones%2C%20luxurious%20cinema%20atmosphere%2C%20professional%20film%20industry%20style%2C%20no%20text%20no%20people&width=800&height=600&seq=hero-visual-mitao-2026&orientation=landscape"
                alt="密桃视频 - 高清影视内容聚合平台主视觉"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-background-50/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}